import headerImage from 'assets/images/header_image.png'
import LogoCSN from 'assets/images/logo_csn_horizontal.png'
import { Title, Button } from 'components'
import ComponentImage from 'components/Image/Image'
import { COLORS, SPACING } from 'utils'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

import {
  Container,
  HeaderMenu,
  ImageContainer,
  LogoContainer
} from './Header.styles'

export const Header = () => {
  const history = useHistory();
  const location = useLocation();
  const isCsnLoginFornecedorScreen = location.pathname === '/ngt/access';
  return (
    <>
      <HeaderMenu elevation={0}>
        <LogoContainer>
          <ComponentImage src={LogoCSN} objectFit="fill" />
        </LogoContainer>
        {!isCsnLoginFornecedorScreen && (
          <Button
            onClick={() => {
              history.push({
                pathname: '/ngt/access'
              })
            }}
            variantButton="default"
            borderColor='black'
            text="ACESSO CSN"
            boxShadow='#E5E4E4'
            backgroundColor='white'
            marginBottom={SPACING.spacing20}
            marginTop={SPACING.spacing20}
            marginRight={SPACING.spacing15}
            width='11em'
            style={{ borderRadius: '10px', color: 'black' }}
          ></Button>)}
      </HeaderMenu>
      <Container>
        <Title marginleft={SPACING.spacing20} fontcolor={COLORS.blueFonts}>
          GESTÃO DE TERCEIROS
        </Title>
        <ImageContainer>
          <ComponentImage src={headerImage} />
        </ImageContainer>
      </Container>
    </>
  )
}
